import { SxProps, Typography } from '@mui/material';
import React from 'react';
import { getBaseVulnerabilityState, VulnerabilityState } from '../VulnerabilityUtils';
import { vars } from '../../../../../Theme';
import AppTooltip from '../../../../General/AppTooltip/AppTooltip';

/** Base tag text styles. */
const textSx: SxProps = {
    borderRadius: 2.5,
    color: vars.white,
    lineHeight: 1,
    height: 20,
    flex: 0,
    py: 0.5,
    px: 1,
    mr: 1,
};

/**
 * Gets the text content and background color for a vulnerability tag.
 * @param status - Vulnerability status.
 */
const getTagProps = (status: VulnerabilityState) => {
    switch (status) {
        case VulnerabilityState.New:
            return ['New', vars.midGray];

        case VulnerabilityState.Active:
            return ['Active', '#FBC62A'];

        case VulnerabilityState.Closed:
            return ['Closed', '#44AC34'];

        case VulnerabilityState.Critical:
            return ['Critical', vars.brandPink];

        case VulnerabilityState.High:
            return ['High', vars.brandOrange];

        case VulnerabilityState.Medium:
            return ['Medium', vars.brandYellow];

        case VulnerabilityState.Low:
            return ['Low', '#44AC34'];

        default:
            return ['None', vars.lightGray];
    }
};

/**
 * Component that shows a vulnerability's status as a colourful 'tag'.
 */
export default (props: { status: string; style?: SxProps }) => {
    /** Determine the vulnerability's base type. */
    const status = getBaseVulnerabilityState(props.status);

    /** Calculate tag props. */
    const [tag, bgcolor] = getTagProps(status);

    const style = props.style;

    return (
        <AppTooltip title={VulnerabilityState[status]}>
            <Typography
                variant='h6'
                fontSize={12}
                sx={{ ...textSx, bgcolor, pl: 1, ml: 2, ...style }}
                children={tag}
            />
        </AppTooltip>
    );
};
